module.exports = __webpack_public_path__ + "static/vaughan-ccce42d029a54e5211139f2d7ca241d5.png";